export default __webpack_public_path__ + "static/media/productImage4.f75d7784.png";